<template>
  <div class="site-closed-container">
    <div class="site-closed-content">
      <div class="site-closed-icon">
        <svg viewBox="0 0 1024 1024" width="80" height="80">
          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" fill="#f59a23"/>
          <path d="M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" fill="#f59a23"/>
        </svg>
      </div>
      <h1 class="site-closed-title">站点维护中</h1>
      <p class="site-closed-message">{{ closeMessage }}</p>
      <div v-if="reopenTime" class="reopen-time">
        <svg viewBox="0 0 1024 1024" width="20" height="20">
          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" fill="#409eff"/>
          <path d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.8l28.6-39.4c2.6-3.6 1.8-8.6-1.8-11.2z" fill="#409eff"/>
        </svg>
        <span>预计恢复时间：{{ reopenTime }}</span>
      </div>
      <div class="countdown" v-if="countdownText">{{ countdownText }}</div>
      <button class="refresh-btn" @click="refreshPage">
        <svg viewBox="0 0 1024 1024" width="16" height="16">
          <path d="M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c177.4 0 328.9-110.4 391.1-266.1 1.7-4.2 2.8-8.5 3.6-12.9l0.1 0.1c0.2-1.1 0.3-2.1 0.5-3.2V648c0-17.7-14.3-32-32-32H732c-17.7 0-32 14.3-32 32v12c0 3.4-0.5 6.6-1.4 9.7-36.6 109.6-139.5 188-260.7 188-148.6 0-269.7-120.8-270-269.5-0.3-148.9 120.5-270.1 269.4-270.1 106.3 0 198.2 61.6 242.2 150.8l-44.3 34.6c-12.2 9.6-13.5 27.5-3.9 39.7l27.8 35.4c9.6 12.2 27.5 13.5 39.7 3.9l209.3-163.6c12.2-9.6 13.5-27.5 3.9-39.7l-27.8-35.4c-9.5-12.2-27.4-13.5-39.6-3.9z" fill="white"/>
        </svg>
        刷新页面
      </button>
    </div>
  </div>
</template>

<script>
// 导入纯净的axios实例（不带拦截器，避免503跳转循环）
import { cleanApiClient } from '@/api/index';

export default {
  name: 'SiteClosed',
  data() {
    return {
      closeMessage: '系统维护中，请稍后访问...',
      reopenTime: '',
      countdownText: '',
      countdownTimer: null,
      pollingTimer: null,
      isRestoring: false // 防止重复跳转
    };
  },
  mounted() {
    console.log('%c🔄 站点关闭页面已加载', 'color: #f59a23; font-weight: bold; font-size: 14px;');
    
    // 从localStorage读取信息
    const message = localStorage.getItem('siteCloseMessage');
    const time = localStorage.getItem('siteReopenTime');
    
    if (message) this.closeMessage = message;
    if (time) {
      this.reopenTime = time;
      this.startCountdown(time);
    }
    
    // 立即检查一次站点状态
    this.checkSiteStatus();
    
    // 启动轮询检查（每10秒）
    this.startPolling();
  },
  beforeUnmount() {
    console.log('清理定时器...');
    // 清除定时器
    if (this.countdownTimer) clearInterval(this.countdownTimer);
    if (this.pollingTimer) clearInterval(this.pollingTimer);
  },
  methods: {
    // 立即检查站点状态
    async checkSiteStatus() {
      if (this.isRestoring) return;
      
      try {
        console.log('🔍 检查站点状态...');
        const response = await cleanApiClient.get('/site/status', {
          params: { platform: 'web' }
        });
        
        console.log('站点状态响应:', response.data);
        
        // 如果站点已恢复（code=200）
        if (response.data.code === 200) {
          this.handleSiteRestored();
        }
      } catch (error) {
        // 503 响应表示站点仍在维护中
        if (error.response && error.response.status === 503) {
          console.log('⚠️ 站点仍在维护中');
        } else {
          console.log('⚠️ 检查站点状态失败（网络或服务器问题）:', error.message);
        }
      }
    },
    
    // 处理站点恢复
    handleSiteRestored() {
      if (this.isRestoring) return;
      this.isRestoring = true;
      
      console.log('%c✅ 站点已恢复！', 'color: #67c23a; font-weight: bold; font-size: 16px;');
      
      // 清除所有定时器
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      if (this.pollingTimer) clearInterval(this.pollingTimer);
      
      // 清除localStorage
      localStorage.removeItem('siteCloseMessage');
      localStorage.removeItem('siteReopenTime');
      
      // 显示恢复提示
      this.closeMessage = '✅ 站点已恢复，正在跳转到首页...';
      
      // 2秒后跳转到首页
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
    },
    
    startCountdown(reopenTime) {
      const updateCountdown = () => {
        const target = new Date(reopenTime).getTime();
        const now = Date.now();
        const diff = target - now;
        
        if (diff <= 0) {
          this.countdownText = '即将恢复';
          // 立即检查站点是否已恢复
          this.checkSiteStatus();
          return;
        }
        
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        
        this.countdownText = `距离恢复还有：${hours}小时 ${minutes}分钟 ${seconds}秒`;
      };
      
      // 立即执行一次
      updateCountdown();
      // 每秒更新
      this.countdownTimer = setInterval(updateCountdown, 1000);
    },
    
    startPolling() {
      console.log('🔄 启动轮询检查（每10秒）');
      
      // 立即执行一次
      setTimeout(() => this.checkSiteStatus(), 5000); // 5秒后第一次检查
      
      // 然后每10秒检查一次
      this.pollingTimer = setInterval(() => {
        this.checkSiteStatus();
      }, 10000); // 10秒
    },
    
    refreshPage() {
      console.log('手动刷新页面...');
      window.location.reload();
    }
  }
};
</script>

<style scoped>
.site-closed-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

.site-closed-content {
  text-align: center;
  padding: 60px 40px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 600px;
  width: 100%;
}

.site-closed-icon {
  margin-bottom: 30px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.site-closed-title {
  font-size: 32px;
  color: #333;
  margin-bottom: 20px;
  font-weight: bold;
}

.site-closed-message {
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  white-space: pre-line;
}

.reopen-time {
  font-size: 16px;
  color: #999;
  margin-bottom: 20px;
  padding: 10px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.countdown {
  font-size: 18px;
  color: #409eff;
  margin-bottom: 30px;
  font-weight: bold;
}

.refresh-btn {
  width: 200px;
  height: 48px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0 auto;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.refresh-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.refresh-btn:active {
  transform: translateY(0);
}

@media (max-width: 768px) {
  .site-closed-content {
    padding: 40px 20px;
  }
  .site-closed-title {
    font-size: 24px;
  }
  .site-closed-message {
    font-size: 16px;
  }
}
</style>
